module.exports = __webpack_public_path__ + "img/under_maintenance.3cc567b3.jpg";